exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__PastWeatherContainer__pastWeatherContainer__10jXW {\n  width: 100%;\n  position: relative;\n}\n", ""]);

// exports
exports.locals = {
	"pastWeatherContainer": "dmb-web__PastWeatherContainer__pastWeatherContainer__10jXW"
};